import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  description:string;
  title:string;

  constructor(private fb: UntypedFormBuilder, private dialogRef: MatDialogRef<ConfirmationDialogComponent>,@Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.description = data.data;
  }

  ngOnInit() {
    this.dialogRef.addPanelClass('my-class');
  }



  close() {
    this.dialogRef.close();
  }
}
